import { CatharsisArgs } from '@wix/thunderbolt-catharsis'
import { PresetsDataList } from './types'

export const getInvalidationHandler = (presets: PresetsDataList): CatharsisArgs['onInvalidation'] => (path, get) => {
	const [, aspect] = path

	if (aspect !== 'presetIds') {
		return
	}
	const presetDataList = get<PresetsDataList | undefined>(path)
	if (presetDataList) {
		presetDataList.forEach((preset) => presets.push(preset))
	}
}
